import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { isNumber } from 'util';
import { padNumber, toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export abstract class NgbDateParserFormatter {
  abstract parse(value: string): NgbDate;
  abstract format(date: NgbDate): string;
}

export class NgbDateISOParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDate {
    if (!value) {
      return null;
    }

    const dateParts = value.trim().split('-');

    return this.getNgbDate(dateParts);
  }

  private getNgbDate(dateParts: string[]): NgbDate {

    if (dateParts.length === 1 && isNumber(dateParts[0])) {
      return new NgbDate(toInteger(dateParts[0]), null, null);
    } else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
      return new NgbDate(toInteger(dateParts[0]), toInteger(dateParts[1]) - 1, null);
    } else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
      return new NgbDate(toInteger(dateParts[0]), toInteger(dateParts[1]) - 1, toInteger(dateParts[2]));
    }

    return null;
  }

  format(date: NgbDate): string {
    return date ?
        `${isNumber(date.day) ? padNumber(date.day) : ''}/${isNumber(date.month) ? padNumber(date.month) : ''}/${date.year}` :
        '';
  }

  criarNgbDateStruct(dataServidor): NgbDateStruct {
    const dataAuxiliar = new Date(dataServidor);

    return { day: dataAuxiliar.getDay(), month: dataAuxiliar.getMonth() + 1, year: dataAuxiliar.getMonth() };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ngb-date-parser-formatter.ts